import { FC } from 'react';
import { ReactComponent as IncreaseIcon } from 'assets/icons/increase-icon.svg';
import { ReactComponent as DecreaseIcon } from 'assets/icons/decrease-icon.svg';

interface PeriodComparisonProps {
  current: number;
  last: number;
  isVsLastPeriod?: boolean;
}

const PeriodComparison: FC<PeriodComparisonProps> = ({
  current,
  last,
  isVsLastPeriod = true,
}) => {
  let percentChange: number;
  if (last === 0) {
    percentChange = current === 0 ? 0 : NaN;
  } else {
    percentChange = ((current - last) / last) * 100;
  }

  const isValid = Number.isFinite(percentChange);
  const isIncrement = isValid && percentChange > 0;
  const isDecrement = isValid && percentChange < 0;

  let colorClass = 'text-darkest-grey';
  let prefix = '';
  if (isIncrement) {
    colorClass = 'text-green';
    prefix = '+';
  } else if (isDecrement) {
    colorClass = 'text-red-01';
    prefix = '-';
  }

  const displayValue = !isValid
    ? 'N/A'
    : percentChange === 0
    ? '0%'
    : `${prefix}${Math.abs(percentChange).toFixed(1)}%`;

  return (
    <div className="flex items-center gap-x-0.4 text-11 leading-[1.8rem]">
      {isIncrement && <IncreaseIcon />}
      {isDecrement && <DecreaseIcon />}
      <span className={`font-bold ${colorClass}`}>{displayValue}</span>
      {isVsLastPeriod && (
        <span className="text-darkest-grey font-normal">vs last period</span>
      )}
    </div>
  );
};

export default PeriodComparison;
